import { defaultStringifySearch } from '@tanstack/react-router'

// TanStack Router's default stringifySearch JSON-encodes array values, so
// `plan: ['jcex', 'esquare']` becomes `plan=%5B%22jcex%22%2C%22esquare%22%5D`,
// which is hard to read and share as a URL. Serialize arrays as repeated
// params (`plan=jcex&plan=esquare`) instead, following eAdmin's convention.
// No custom parseSearch is needed: the default parser already merges repeated
// keys back into an array (a single occurrence parses as a plain string, which
// each route's validateSearch must accept).
export function stringifySearch(search: Record<string, unknown>): string {
  const scalars: Record<string, unknown> = {}
  const repeated: string[] = []
  for (const [key, value] of Object.entries(search)) {
    if (!Array.isArray(value)) {
      scalars[key] = value
      continue
    }
    for (const v of value) {
      repeated.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`,
      )
    }
  }
  const searchStr = defaultStringifySearch(scalars)
  if (repeated.length === 0) {
    return searchStr
  }
  return `${searchStr === '' ? '?' : `${searchStr}&`}${repeated.join('&')}`
}
